import { getFirestore } from 'firebase/firestore';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAurEpiXY_NE-0DrifaJ3nFkXp0ve0M9as",
  authDomain: "disease-prediction-app-db.firebaseapp.com",
  projectId: "disease-prediction-app-db",
  storageBucket: "disease-prediction-app-db.appspot.com",
  messagingSenderId: "778905088428",
  appId: "1:778905088428:web:0eef3aa34c0bbec15a8a09",
  measurementId: "G-E32D00X9BH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore();